import 'slick-carousel'

export default () => {

  $('.slideshow').each(function() {
    $(this).slick({
      slidesToShow: 1,
      fade: true,
      dots: true,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M3.75 0.625L0.625 3.75M0.625 3.75L3.75 6.875M0.625 3.75H15.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M12.5 0.625L15.625 3.75M15.625 3.75L12.5 6.875M15.625 3.75H0.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            arrows: false
          }
        }
      ]
    });
  });

  $('.items-slider').each(function() {
    $(this).slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M3.75 0.625L0.625 3.75M0.625 3.75L3.75 6.875M0.625 3.75H15.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M12.5 0.625L15.625 3.75M15.625 3.75L12.5 6.875M15.625 3.75H0.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1430,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
  $('.reviews__slider').each(function() {
    $(this).slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M3.75 0.625L0.625 3.75M0.625 3.75L3.75 6.875M0.625 3.75H15.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next first-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                  <path d="M12.5 0.625L15.625 3.75M15.625 3.75L12.5 6.875M15.625 3.75H0.625" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js